// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconProps } from "@insite/mobius/Icon";
import IconClear from "@stoneage/XDL/Icons/IconClear";
import IconHeaderMenu from "@stoneage/XDL/Icons/IconHeaderMenu";
import { xScreen } from "@stoneage/XDL/Utilities";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface OwnProps {}

const mapStateToProps = (state: ApplicationState) => ({
    navDrawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
});

const mapDispatchToProps = {
    setFlyoutDrawerIsOpen,
    setInitialValues,
    setNavDrawerIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MainNavigationButtonStyles {
    clickable?: ClickablePresentationProps;
    icon?: IconProps;
}

export const mainNavigationButtonStyles: MainNavigationButtonStyles = {
    clickable: {
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: flex;
            }
        `,
    },
    icon: {
        size: 18,
        color: "secondary",
    },
};

const styles = mainNavigationButtonStyles;
const MainNavigationButton: FC<Props> = ({ navDrawerIsOpen, setNavDrawerIsOpen, setInitialValues }) => {
    const openDrawer = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: true });
        setInitialValues({});
    };

    const closeDrawer = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    return (
        <Clickable {...styles.clickable} onClick={navDrawerIsOpen ? closeDrawer : openDrawer}>
            <Icon {...styles.icon} src={navDrawerIsOpen ? IconClear : IconHeaderMenu} />
        </Clickable>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNavigationButton);
